import {createAction} from "@reduxjs/toolkit";

export const startCall = createAction("call/start");
export const updateLayoutClass = createAction("update/layout/class");
export const updateLayoutOption = createAction("update/layout/option");
